import { autoinject, computedFrom, bindable } from 'aurelia-framework';
import { LocationState } from "../../store/state";
import { IState } from "../../store/state";
import { Store } from "aurelia-store";
import { Location } from "../../models/location";
import { I18N } from "aurelia-i18n";
import { DialogService, DialogSettings } from "aurelia-dialog";
import { AddLocationDialog } from "./dialogs/add-location-dialog";
import { applicationLogger } from "../../logging/logger";
import { Api } from "../../services/api";

@autoinject
export class LocationAdminCard {
	locationState: LocationState;
	locations = new Array<Location>();
	@bindable locationCount: number;
	store: Store<IState>;
	i18n: I18N;
	api: Api;
	dialogService: DialogService;
	
	loading: boolean = false;
	message: string;

	private subscription: any;

	constructor(store: Store<IState>, i18n: I18N, dialogService: DialogService, api: Api) {
		this.store = store;
		this.i18n = i18n;
		this.api = api;
		this.dialogService = dialogService;
	}

	async bind(bindingContext: any, overrideContext: any) {
		//this.subscription = this.store.state.subscribe((state) => {
		//	this.applicationState = state;
		//	this.locationState = Object.assign({}, this.applicationState.locationState);
		//	this.locations = this.locationState.locations;
		//	this.locationCount = this.locations.length;
		//});

		await this.getData();

	}

	async getData() {
		this.message = this.i18n.tr("loading-data");
		this.loading = true;
		this.locations = await this.api.getLocations();
		this.locationCount = this.locations.length;
		this.loading = false;
	}

	unbind() {
		//this.subscription.unsubscribe();
	}

	attached() {

	}

	detached() {

	}

	@computedFrom("locationCount")
	get caption() {
		let caption = null;

		if (this.locationCount > 1 || this.locationCount === 0) {
			caption = this.i18n.tr("locations");
		} else {
			caption = this.i18n.tr("location");
		}

		return caption;
	}

	addLocation() {
		this.dialogService.open({ viewModel: AddLocationDialog, model: null, lock: false } as DialogSettings).whenClosed(response => {
			if (!response.wasCancelled) {
				applicationLogger.debug('Dialog OK clicked - ', response.output);
			} else {
				applicationLogger.debug('Dialog canceled');
			}
			applicationLogger.debug(response.output);
		});
	}

}